<div
  class="rs-type-item"
  matRipple
  matRippleColor="#00a7ef10"
  [class.rs-type-item_selected]="selected"
>
  <div class="rs-type-item__title">{{caption}}</div>
</div>
